import React, { Component } from "react"
import { Input, Button, Affix, message, Select } from "antd"
import { observer, inject } from "mobx-react"
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import styled from 'styled-components'
import { action, observable } from "mobx"
import moment from "moment"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"

const InputGroup = Input.Group
const Option = Select.Option

const CreateAccountBtn = styled.button`
  width: 127px;
  height: 40px;
  background: #286CAC;
  color: white;
  font-size: 14px;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
`

@inject("auth", "store") @observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dayKey: "-1",
      createModalShowed: false
    }
  }

  componentDidMount() {
    this.props.auth.getApps()
  }

  @action
  changeSearch = (e) => {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    const {
      list: { filterData }
    } = this.props.store
    const keywords = e.target.value

    this.timer = setTimeout(() => {
      this.timer = null
      this.setState({
        inputSearch: keywords,
      })
      filterData({ keywords })
    }, 300)
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  showCreateAccountModal = () => {
    this.setState({
      createModalShowed: true
    })
  }

  render() {
    const { createModalShowed } = this.state
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          <div className="statistics-search-bar">
            <div className="search-input">
              <InputGroup className="ant-search-input">
                <Input
                  placeholder="输入用户名进行搜索"
                  size="default"
                  onChange={this.changeSearch}
                />
                <div className="ant-input-group-wrap">
                  <Button icon="search" className="ant-search-btn" size="default" />
                </div>
              </InputGroup>
            </div>
            <CreateAccountBtn
              className="create-account-btn"
              onClick={() => this.showCreateAccountModal()}
            >
              + 创建子账户
            </CreateAccountBtn>
          </div>

          {createModalShowed && (
            <CreateAccountModal
              store={this.props.store}
              onClose={() => this.setState({ createModalShowed: false })}
            />)
          }
        </div>
      </Affix>
    )
  }

  onDataChange = (e, type) => {
    this.props.store.tableData = []

    switch (type) {
      case "belong": this.onBelongChange(e)
        break
      case "app": this.onAppChange(e)
        break
      case "day": this.onDayChange(e)
        break
      default: this.dateChangeOk()
    }
  }

  onAppChange = (e) => {
    const {
      list: { filterData, selectAllApp }
    } = this.props.store
    if (e.includes("all")) {
      filterData({ appIds: selectAllApp() })
    } else {
      filterData({ appIds: e })
    }
  }

  onDayChange = (e) => {
    let startDay = null
    const {
      list: { filterData }
    } = this.props.store

    this.setState({  //设置近几天同时重置日期选择
      dayKey: e.key,
      dateValue: null,
    })
    if (e.key !== "-1") {
      startDay = moment(moment() - e.key * 1000 * 3600 * 24).format("YYYY-MM-DD")
    }

    filterData({ start: startDay, end: null })
  }

  dateChangeOk = () => {
    this.setState({  // 重置近几天的选项
      dayKey: "-1",
    })
    let {
      list: { filterData, queryMap }
    } = this.props.store

    filterData({ end: moment(queryMap.end, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
  }
}

@inject("auth", "store") @observer
class CreateAccountModal extends Component {
  @observable submitData = {
    username: "",
    truename: "",
    password: "",
    repassword: "",
    phone: "",
    email: "",
    orgId: "",
    apps: [],
    appIds: []
  }

  onInputChange = (field, value) => {
    this.submitData[field] = value
  }

  confirmCreate = () => {
    const { onClose } = this.props
    const { store: { list } } = this.props
    const { password, repassword, apps } = this.submitData

    if (apps.indexOf('pgs') === -1) delete this.submitData.appIds
    if (password === repassword) {
      this.props.store.createAccount({ ...this.submitData })
        .then(res => {
          message.success('账号创建成功')
          list.getTableData()
            .then(
              res => {
                onClose()
                list.updateTableData(res)
                list.initPageIndex()
              }
            )
        }, err => {
          message.error(err)
        })
    } else {
      message.error('两次输入的密码不一致，请重新输入')
    }
  }

  render() {
    const { onClose } = this.props
    const { orgList } = this.props.store
    const { apps, channelApps } = this.props.auth
    const showChannel = this.submitData.apps.indexOf('pgs') > -1

    return (
      <MaterialModal
        title="创建子账户"
        width={450}
        className="preview-account-create-modal"
        buttonText="确认添加"
        visible
        action={() => this.confirmCreate()}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <MaterialForm>
          <MaterialFormItem
            labelText="用户名"
            labelWidth={70}
          >
            <Input
              className="createAccount-input"
              placeholder="请输入用户名"
              value={this.submitData.username}
              onChange={(e) => this.onInputChange("username", e.target.value)}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={70}
            labelText="姓名"
            justify="center"
          >
            <Input
              name="name"
              className="createAccount-input"
              placeholder="请输入姓名"
              value={this.submitData.truename}
              onChange={(e) => this.onInputChange("truename", e.target.value)}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={70}
            labelText="密码"
            justify="center"
          >
            <Input
              name="password"
              className="createAccount-input"
              type="password"
              placeholder="请输入密码"
              value={this.submitData.password}
              onChange={(e) => this.onInputChange("password", e.target.value)}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={70}
            labelText="确认密码"
            justify="center"
          >
            <Input
              name="repassword"
              type="password"
              className="createAccount-input"
              value={this.submitData.repassword}
              placeholder="请再次输入密码"
              onChange={(e) => this.onInputChange("repassword", e.target.value)}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={70}
            labelText="手机号码"
            justify="center"
          >
            <Input
              name="phone"
              className="createAccount-input"
              value={this.submitData.phone}
              placeholder="请输入手机号码"
              onChange={(e) => this.onInputChange("phone", e.target.value)}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={70}
            labelText="邮箱"
            justify="center"
          >
            <Input
              name="email"
              value={this.submitData.email}
              className="createAccount-input"
              placeholder="请输入邮箱地址"
              onChange={(e) => this.onInputChange("email", e.target.value)}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={70}
            labelText="所属机构"
            justify="center"
          >
            <Select
              showSearch
              placeholder="请选择所属机构"
              className="createAccount-input"
              onChange={(e) => this.onInputChange("orgId", e)}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {orgList.slice().map(org => <Option key={org.id}>{org.name}</Option>)}
            </Select>
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={70}
            labelText="可操作应用"
            justify="center"
          >
            <Select
              placeholder="请选择可操作应用"
              className="createAccount-input"
              multiple
              onChange={(e) => this.onInputChange("apps", e)}
            >
              {apps.slice().map(app => <Option key={app}>{app}</Option>)}
            </Select>
          </MaterialFormItem>
          {showChannel && (
            <MaterialFormItem
              labelWidth={70}
              labelText="PGS上传通道"
              justify="center"
            >
              <Select
                placeholder="请选择pgs上传通道"
                className="createAccount-input"
                multiple
                onChange={(e) => this.onInputChange("appIds", e)}
              >
                {channelApps.slice().map(app => <Option key={app.id}>{app.name}</Option>)}
              </Select>
            </MaterialFormItem>
          )}
        </MaterialForm>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/bypass-account/containers/DataHeader.js